import { render, staticRenderFns } from "./SelecionarAluguelDialog.vue?vue&type=template&id=1b13d7e4&"
import script from "./SelecionarAluguelDialog.vue?vue&type=script&lang=js&"
export * from "./SelecionarAluguelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports